 <!-- 月度报表 -->
 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="monthleReportForm" :model="monthleReportForm" 
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="monthleReportForm.ckName" clearable>
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="searchDate">搜索</el-button>
                <el-button type="primary" @click="inventoryCountExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <el-tabs v-model="activeName" @tab-click="handleClick" style="flex: 1;height:100%;">
                <el-tab-pane label="作业数据" name="first" class="tab-pane-full-height">
                    <vxe-table id="dailyReportTable"  size="mini" ref="dailyReportTable" :data="monthleReportList" border stripe
                    header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="98%"
                    :row-config="{isCurrent: true, isHover: true}">
                        <vxe-column field="month" title="月份" width="110" ></vxe-column>
                        <vxe-column field="inTons" title="入库（吨）" width="110" ></vxe-column>
                        <vxe-column field="outTons" title="出库（吨）" ></vxe-column>
                        <vxe-column field="totalTons" title="出+入（吨）"  ></vxe-column>
                        <vxe-column field="inCars" title="入库车次"   ></vxe-column>
                        <vxe-column field="outCars" title="出库车次" ></vxe-column>
                        <vxe-column field="ykTons" title="倒库（吨）" ></vxe-column>
                        <vxe-column field="stockTons" title="结存（吨）" ></vxe-column>
                        <vxe-column field="avgStockTons" title="平均结存（吨）"  ></vxe-column>
                    </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="客户统计" name="second" class="tab-pane-full-height">
                    <vxe-table id="customerReportTable"  size="mini" ref="customerReportTable" :data="customerReportList" border stripe
                    header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="98%"
                    :row-config="{isCurrent: true, isHover: true}"  >
                        <vxe-column field="cusName" title="客户名称" width="200" fixed="left" 
                        :filters="cusNameOptions" :filter-method="filterMethod">
                            <template #filter="{ $panel, column }">
                                <!-- 只留一个输入框，绑定第一条筛选项 -->
                                <el-input size="mini"
                                placeholder="输入客户名称模糊搜索"
                                v-model="column.filters[0].data"
                                @input="$panel.changeOption($event, !!column.filters[0].data, column.filters[0])"
                                />
                            </template>
                        </vxe-column>
                        <vxe-colgroup :title="item.label" v-for="(item, index) in monthList" :key="index">
                            <vxe-column :field="`col_in_${index}`" title="入库(吨)" width="90" :formatter="({ row }) => getCellValue(row, item.label, 'inTons')"></vxe-column>
                            <vxe-column :field="`col_out_${index}`" title="出库(吨)" width="90" :formatter="({ row }) => getCellValue(row, item.label, 'outTons')"></vxe-column>
                            <vxe-column :field="`col_stock_${index}`" title="结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, item.label, 'stockTons')"></vxe-column>
                            <vxe-column :field="`col_avg_${index}`" title="平均结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, item.label, 'avgStockTons')"></vxe-column>
                        </vxe-colgroup>
                    </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="货物大类统计" name="third"  class="tab-pane-full-height">
                    <vxe-table id="goodsTypeReportTable"  size="mini" ref="goodsTypeReportTable" :data="goodsTypeReportList" border stripe
                    header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="98%"
                    :row-config="{isCurrent: true, isHover: true}"  >
                        <vxe-column field="goodsType" title="货物大类" width="160" fixed="left" 
                        :filters="goodsTypeOptions" :filter-method="filterMethod">
                            <template #filter="{ $panel, column }">
                                <!-- 只留一个输入框，绑定第一条筛选项 -->
                                <el-input size="mini"
                                placeholder="输入货物大类模糊搜索"
                                v-model="column.filters[0].data"
                                @input="$panel.changeOption($event, !!column.filters[0].data, column.filters[0])"
                                />
                            </template>
                        </vxe-column>
                        <vxe-colgroup :title="item.label" v-for="(item, index) in monthList" :key="index">
                            <vxe-column :field="`col_in_${index}`" title="入库(吨)" width="90" :formatter="({ row }) => getCellValue(row, item.label, 'inTons')"></vxe-column>
                            <vxe-column :field="`col_out_${index}`" title="出库(吨)" width="90" :formatter="({ row }) => getCellValue(row, item.label, 'outTons')"></vxe-column>
                            <vxe-column :field="`col_stock_${index}`" title="结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, item.label, 'stockTons')"></vxe-column>
                            <vxe-column :field="`col_avg_${index}`" title="平均结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, item.label, 'avgStockTons')"></vxe-column>
                        </vxe-colgroup>
                    </vxe-table>
                </el-tab-pane>
            </el-tabs>
            
        </div>

    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";

export default {
    name: 'monthlyReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            activeName: 'first', // 默认选中
            cusNameOptions:[
                { data: '' }
            ],
            goodsTypeOptions:[
                { data: '' }
            ],
            monthleReportForm:{
                ckName:"",
            },
            monthleReportList:[],
            ckNameList:[], // 获取仓库列表
            customerReportList:[], // 客户统计
            goodsTypeReportList:[], // 货物大类统计
            monthList:[
                {value:'1',label:'1月'},
                {value:'2',label:'2月'},
                {value:'3',label:'3月'},
                {value:'4',label:'4月'},
                {value:'5',label:'5月'},
                {value:'6',label:'6月'},
                {value:'7',label:'7月'},
                {value:'8',label:'8月'},
                {value:'9',label:'9月'},
                {value:'10',label:'10月'},
                {value:'11',label:'11月'},
                {value:'12',label:'12月'},
                {value:'月均',label:'月均'},
                {value:'全年',label:'全年'},
            ]
        }
    },
    async created() {
        await this.getckNameList()
        await this.getMonthleReportList()

    },
    mounted() {

    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == 'first'){
                if( this.monthleReportList.length === 0  ){
                    this.getMonthleReportList()
                }
            }else if (tab.name == 'second'){
                if( this.customerReportList.length === 0  ){
                    this.wmsGetMonthReportWithCustomer()
                }
            }else if (tab.name == 'third'){
                if( this.goodsTypeReportList.length === 0  ){
                    this.wmsGetMonthReportWithGoodsType()
                }
            }

        },
        // 搜索按钮
        searchDate(){
            if(this.activeName === 'first'){
                this.getMonthleReportList()
            }else if(this.activeName === 'second'){
                this.wmsGetMonthReportWithCustomer()
            }else if (tab.name == 'third'){
                this.wmsGetMonthReportWithGoodsType()
            }
        },
        // 比较数据与列的月份是否相同
        getCellValue(row, targetMonthLabel, fieldKey) {
            const targetItem = row.contents.find(item => item.month === targetMonthLabel);
            if (!targetItem) return '';
            return targetItem[fieldKey] ?? '';
            // 如果数据量大，可以提前对每一行数据预处理，把contents转成key-value映射表：
            // js
            // // 拿到接口customerReportList后预处理
            // this.customerReportList = res.data.map(row => {
            // const monthMap = {};
            // row.contents.forEach(item => {
            //     monthMap[item.month] = item;
            // });
            // return {
            //     ...row,
            //     monthMap
            // };
            // })
            // getCellValue(row, targetMonthLabel, fieldKey) {
            // const targetItem = row.monthMap[targetMonthLabel];
            // return targetItem?.[fieldKey] ?? '';
            // }
        },
        // 获取数据
        getMonthleReportList() { 
                return this.$api.wmsGetMonthStockTons(this.monthleReportForm.ckName).then(res =>{
                    this.monthleReportList = res
                })
        },
        // 获取客户月报数据
        wmsGetMonthReportWithCustomer(){
            return this.$api.wmsGetMonthReportWithCustomer( this.monthleReportForm.ckName ).then(res =>{
                this.customerReportList = res

            })
        },
        wmsGetMonthReportWithGoodsType(){
            return this.$api.wmsGetMonthReportWithGoodsType( this.monthleReportForm.ckName ).then(res =>{
                this.goodsTypeReportList = res
            })
        },
        // 表格客户/货物大类过滤
        filterMethod ({ option, row }) {
            // option.data 是筛选项绑定的文本内容
            const keyword = option.data?.toString() || ''
            // 转小写模糊匹配，只要row.cusName包含关键字就返回true
            return row.cusName?.toLowerCase().includes(keyword.toLowerCase())
        },
        // 表格货物大类过滤
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
               this.monthleReportForm.ckName = this.ckNameList[0]
            })
        },
        // 导出
        async inventoryCountExport(){
            // 收集需要执行的异步任务
            const taskList = [];

            if (this.monthleReportList.length === 0) {
            taskList.push(this.getMonthleReportList());
            }
            if (this.customerReportList.length === 0) {
            taskList.push(this.wmsGetMonthReportWithCustomer());
            }
            if (this.goodsTypeReportList.length === 0) {
            taskList.push(this.wmsGetMonthReportWithGoodsType());
            }

            // 并发一起执行，全部结束再往下走后续逻辑
            if (taskList.length > 0) {
            await Promise.all(taskList);
            }
            // 客户数据
            const flatCustomerData = [];
            this.customerReportList.forEach(cus => {
                cus.contents.forEach(monthItem => {
                    flatCustomerData.push({
                        cusName: cus.cusName,
                        inTons: monthItem.inTons,
                        outTons: monthItem.outTons,
                        stockTons: monthItem.stockTons,
                        avgStockTons: monthItem.avgStockTons,
                        month: monthItem.month
                    })
                })
            })
            // 货物大类数据
            const flatgoodsTypeData = [];
            this.goodsTypeReportList.forEach(goods => {
                goods.contents.forEach(monthItem => {
                    flatgoodsTypeData.push({
                        goodsType: goods.goodsType,
                        inTons: monthItem.inTons,
                        outTons: monthItem.outTons,
                        stockTons: monthItem.stockTons,
                        avgStockTons: monthItem.avgStockTons,
                        month: monthItem.month
                    })
                })
            })
            const params = { 
                table1:this.monthleReportList,
                table2:flatCustomerData,
                table3:flatgoodsTypeData,
            }
            let downloadName = `${this.monthleReportForm.ckName}月报表.xls`

            var args = {
                report: urlAddRandomNo("/grf/月报表.grf"),
                data: params,
                type: "xls",
                filename: downloadName,
                ExportPageBreak: false, // 导出Excel时是否保留分页符
                ExportPageHeaderFooter: false, // 导出Excel时是否保留页眉页脚
                SameAsPrint: false, // 导出Excel时是否与和纸质打印一致
                showOptionDlg: true, // 是否弹出导出设置弹窗
                ExcelKeepCellFormat: true,// 导出Excel时是否保持单元格格式
            };
            webapp_ws_ajax_run(args);
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .el-tabs__content {
    height: calc(100% - 40px) !important; /* 减去顶部标签栏高度，剩余全部给内容面板 */
    overflow: hidden;
}
/deep/ .tab-pane-full-height {
    width: 100%;
    height: 100%;
}
/* 清空tab-pane默认内边距，避免留白挤压高度 */
/deep/ .el-tab-pane {
    padding: 0 !important;
}
</style>
